module.exports = __webpack_public_path__ + "static/media/channel.adf7c8dc.svg";